import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { ContentBox, StyledDivider } from './UnderstandTrials.style';
import { UnderstandTrialsProps } from './UnderstandTrials.types';
import { JSSLink } from '../shared/Links/JSSLink.styles';
import UiHeading from '../shared/Heading';
import UiBox from '../shared/Box';

const UnderstandTrials = (props: UnderstandTrialsProps): JSX.Element => {
  const theme = useTheme();

  if (!props.fields) {
    return <></>;
  }

  return (
    <>
      <style jsx global>{`
        /* Hide UnderstandTrials on initial load in iframe mode to prevent flicker */
        html.iframe-mode .understand-trials {
          display: none !important;
        }
      `}</style>
      <ContentBox className="understand-trials">
        <UiBox styles={{ padding: '0 20px' }}>
          <UiHeading size="h3" data-testid="title" align="center" color="primary" isChildren>
            <Text field={props?.fields?.title} />
          </UiHeading>
        </UiBox>
        <StyledDivider />
        <Typography
          variant="body"
          sx={{ color: theme.palette.backgroundType1.main, fontWeight: 600, marginBottom: '8px' }}
        >
          <Text field={props?.fields?.subTitle} />
        </Typography>
        {props?.fields?.ctaLinks?.length > 0 &&
          props?.fields?.ctaLinks.map((item) => (
            <JSSLink
              className={'understand-trial-btn btn'}
              sx={{
                lineHeight: '18px',
                fontSize: '0.875rem',
                fontWeight: 500,
                textAlign: 'left !important',
                alignSelf: 'stretch',
                color: theme.palette.primary.main,
              }}
              key={item?.id}
              field={item?.fields?.link}
            />
          ))}
      </ContentBox>
    </>
  );
};

export default UnderstandTrials;
